import Page from 'modules/Page';
import * as constants from './constants';
import PourDetailsRedirect from './PourDetailsRedirect';

// The old per-pour note route now only redirects to the unified stope-scoped note page
// (see PourDetailsRedirect). The page component itself lives in StopeNotePage.
const page: Page<constants.PourDetailsPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: PourDetailsRedirect,
};

export default page;
